module.exports = __webpack_public_path__ + "static/img/sc14.5333a12.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/sc14.png
// module id = +l0t
// module chunks = 25